/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Eletromagnetismo() {
  return (
    <PaginasEspecificas posicao="7" endereco="/fisica" materia="Física" />
  );
}

export default Eletromagnetismo;
